import React from 'react';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { t } from 'Src/i18n';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { Slider } from 'Components/frameworks/slider/Slider';
import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { ThematicCard } from './ThematicCard';
type ThematicLineItem = {
  mediaUrl: string;
  link?: string;
  isExclusiveCollection: boolean;
  itemTitle: string;
};
type Props = {
  items: Array<ThematicLineItem>;
  title?: string;
};
export const ThematicLine = ({ title, items }: Props) => {
  // use isDesktop to display slider's controls only on desktops
  const { isTablet, isDesktop } = useResponsive();
  return (
    <SiteContainer className="Line" id="thematic">
      {!!title && <LineTitle>{title}</LineTitle>}
      <Slider
        cols={0}
        hasControls={isDesktop}
        navPosition="center"
        nbItemsToScroll={isTablet ? 2 : 1}
        nextLabel={t('common.next')}
        previousLabel={t('common.previous')}
        scrollAreaContainerClassName="gap-20 scrollbar-hidden scroll-x scroll-smooth"
        scrollControlsClassName="-mx-20 lg:mx-0"
      >
        {items.map(({ isExclusiveCollection, itemTitle, link, mediaUrl }) => (
          <ThematicCard
            key={itemTitle}
            isExclusiveCollection={isExclusiveCollection}
            itemTitle={itemTitle}
            link={link}
            mediaUrl={mediaUrl}
          />
        ))}
      </Slider>
    </SiteContainer>
  );
};
